export default __webpack_public_path__ + "static/media/TransportationCars_09.6318c633.png";